module.exports = __webpack_public_path__ + "img/dian.07ec1bc6.png";